/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailboxAttachmentDTO
 */
export interface MailboxAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxAttachmentDTO
     */
    Id?: string;
    /**
     * 
     * @type {string}
     * @memberof MailboxAttachmentDTO
     */
    PublicUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxAttachmentDTO
     */
    FileNameUploaded?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxAttachmentDTO
     */
    FileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MailboxAttachmentDTO
     */
    FileSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof MailboxAttachmentDTO
     */
    ContentType?: string | null;
}

/**
 * Check if a given object implements the MailboxAttachmentDTO interface.
 */
export function instanceOfMailboxAttachmentDTO(value: object): value is MailboxAttachmentDTO {
    return true;
}

export function MailboxAttachmentDTOFromJSON(json: any): MailboxAttachmentDTO {
    return MailboxAttachmentDTOFromJSONTyped(json, false);
}

export function MailboxAttachmentDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxAttachmentDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'] == null ? undefined : json['Id'],
        'PublicUrl': json['PublicUrl'] == null ? undefined : json['PublicUrl'],
        'FileNameUploaded': json['FileNameUploaded'] == null ? undefined : json['FileNameUploaded'],
        'FileName': json['FileName'] == null ? undefined : json['FileName'],
        'FileSizeBytes': json['FileSizeBytes'] == null ? undefined : json['FileSizeBytes'],
        'ContentType': json['ContentType'] == null ? undefined : json['ContentType'],
    };
}

export function MailboxAttachmentDTOToJSON(json: any): MailboxAttachmentDTO {
    return MailboxAttachmentDTOToJSONTyped(json, false);
}

export function MailboxAttachmentDTOToJSONTyped(value?: MailboxAttachmentDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'PublicUrl': value['PublicUrl'],
        'FileNameUploaded': value['FileNameUploaded'],
        'FileName': value['FileName'],
        'FileSizeBytes': value['FileSizeBytes'],
        'ContentType': value['ContentType'],
    };
}

